module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_icons/icn-caption-a9426b8136ef72e5e04c102651f2f3c0.svg";